
import moment from 'moment'
import Vue from 'vue'
import Api from '@/api'
import { User } from './classes/User'
import momentTz from 'moment-timezone'

Vue.filter('formatDateEST', function (value: string | Date) {
  return momentTz(String(value)).tz('America/New_York').format('MM/DD/YYYY')
})
Vue.filter('formatDateUTC', function (value: string | Date) {
  return momentTz(String(value)).utc().format('MM/DD/YYYY')
})

Vue.filter('formatDateTime', function (value: string | Date) {
  if (value) {
    const user: User = Api.getUser() as User
    return moment(String(value)).utcOffset(user.getTimezone() * 60).format('MM/DD/YYYY hh:mm')
  }
})
Vue.filter('shortDate', function (value: string | Date) {
  if (value) {
    return moment(String(value)).format('MM/YY')
  }
})
Vue.filter('formatMonth', function (value: string | Date) {
  if (value) {
    return moment(String(value)).format('MMMM')
  }
})

Vue.filter('formatDateWithoutTimezone', function (value: string | Date) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
})
Vue.filter('formatDate', function (value: string | Date) {
  if (value) {
    const user: User = Api.getUser() as User
    return moment(String(value)).utcOffset(user.getTimezone() * 60).format('MM/DD/YYYY')
  }
})
Vue.filter('symbolCurrency', function (value: string | number) {
  let num = +value
  const map = {
    B: 1000000000,
    M: 1000000,
    K: 1000
  }
  const resultMap = {
    B: 0,
    M: 0,
    K: 0,
    N: 0
  }
  if (num < map.K) {
    return num.toFixed(0)
  }
  while (num > map.B) {
    resultMap.B++
    num = num - map.B
  }
  while (num > map.M) {
    resultMap.M++
    num = num - map.M
  }
  while (num > map.K) {
    resultMap.K++
    num = num - map.K
  }
  if (num > 99) {
    resultMap.N = parseInt(num.toString().substr(0, 1), 10)
  } else {
    resultMap.N = +num.toFixed(0)
  }
  if (resultMap.B) {
    return `${resultMap.B}B `
  }
  if (resultMap.M) {
    return `${resultMap.M}M `
  }
  if (resultMap.K || resultMap.N) {
    return `${resultMap.K}K `
  }
})
